/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_10_P1Inputs */

const en_terms_section_10_p1 = /** @type {(inputs: Terms_Section_10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These terms are governed by the law of the Republic of Latvia. Any dispute arising from them falls under the exclusive jurisdiction of the Latvian courts.`)
};

const lv_terms_section_10_p1 = /** @type {(inputs: Terms_Section_10_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šiem noteikumiem piemērojami Latvijas Republikas likumi. Jebkurš no tiem izrietošs strīds ir Latvijas tiesu ekskluzīvā jurisdikcijā.`)
};

/**
* | output |
* | --- |
* | "These terms are governed by the law of the Republic of Latvia. Any dispute arising from them falls under the exclusive jurisdiction of the Latvian courts." |
*
* @param {Terms_Section_10_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_10_p1 = /** @type {((inputs?: Terms_Section_10_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_10_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_10_p1(inputs)
	return en_terms_section_10_p1(inputs)
});